import { Button, CircularProgress, Grid, Stack, Typography } from '@mui/material'
import type { FC } from 'react'
import { Redirect } from 'react-router-dom'

import ErrorPage from '@/components/UI/ErrorPage'
import useUser from '@/hooks/useUser'
import { getNextApplicantQuery } from '@/lib/apollo'

const GoToNextApplicant: FC = () => {
  const { personId, customerId } = useUser()

  const { data, loading, error, refetch } = getNextApplicantQuery.useQuery({
    variables: {
      userId: personId,
      customerId,
    },
  })

  const transformedData = getNextApplicantQuery.toTransformedData(data)

  if (loading) {
    return (
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '100vh' }}
      >
        <Grid item>
          <Stack alignItems="center" spacing={2}>
            <CircularProgress size={50} data-testid="next-applicant-loading" />
            <Typography variant="h5">Finding applicant...</Typography>
          </Stack>
        </Grid>
      </Grid>
    )
  }

  if (error || transformedData === undefined) {
    const badRequestErrorMessage = error?.graphQLErrors?.find(
      graphQLError => graphQLError.extensions?.code === 'BAD_REQUEST',
    )?.message

    return (
      <ErrorPage message={badRequestErrorMessage}>
        <Button
          sx={{ lineHeight: 'inherit', marginTop: '10px' }}
          variant="contained"
          onClick={() => refetch()}
          size="medium"
        >
          Retry?
        </Button>
      </ErrorPage>
    )
  }

  if (transformedData?.subjectId === undefined) {
    return (
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '100vh' }}
      >
        <Grid item>
          <Stack alignItems="center" spacing={2}>
            <img
              src="/assets/svg/no-new-applicants.svg"
              style={{ width: '290px' }}
              alt=""
            />
            <Typography variant="h5" fontWeight="bold">
              No new applicants available at this time
            </Typography>
            <Button
              sx={{ lineHeight: 'inherit', marginTop: '10px' }}
              variant="contained"
              onClick={() => refetch()}
              size="medium"
            >
              Look again?
            </Button>
          </Stack>
        </Grid>
      </Grid>
    )
  }

  return <Redirect to={`/applicant/${transformedData.subjectId}`} />
}

export default GoToNextApplicant
